module.exports = __webpack_public_path__ + "static/media/MacPortraitw300@1x.666adc9a.jpg";